import React, { Component } from "react";
import axios from "axios";
import { connect } from "react-redux";
import { setError, setLoading, skipPayment } from "../../duck/basic";
import { postPayment } from "../../duck/payment";
import { Button, Icon, Header, Popup, Segment } from "semantic-ui-react";
import PaymentForm from "./PaymentForm";
import { usStates } from "../../../../../common/_us_states";
import { Warning } from "../../components";

import encrypt, { encryptInfo } from "helpers/encrypt";

import { addressValid } from "../../helpers/addressSchema";

class Payment extends Component {
  state = {
    address: "",
    city: "",
    email: "",
    fullName: "",
    state: "",
    zip: "",
    info: "",
  };

  onSubmit = (formData) => {
    const cardData = {
      cardNumber: formData.cardNumber,
      month: formData.expMonth,
      year: formData.expYear,
      cardCode: formData.code,
      fullName: formData.fullName,
      zip: formData.zip,
      email: formData.email,
    };

    const info = `${formData.zip}${formData.cardNumber.substr(
      formData.cardNumber.length - 5
    )}${formData.expMonth}${formData.expYear}`;

    this.props.dispatch(setLoading(true));

    this.setState({
      address: formData.address,
      city: formData.city,
      email: formData.email,
      state: formData.state,
      zip: formData.zip,
      info: encryptInfo(info).content,
    });

    const authData = {
      clientKey: process.env.AUTHORIZE_CLIENT_KEY,
      apiLoginID: process.env.AUTHORIZE_API_LOGIN_ID,
    };

    const secureData = {
      authData,
      cardData,
    };

    Accept.dispatchData(secureData, this.paymentResponseHandler);
  };

  paymentResponseHandler = (res) => {
    const { resultCode } = res.messages;

    if (resultCode === "Error") {
      if (res.messages.message.length) {
        this.props.dispatch(setError(res.messages.message[0].text));
      } else
        this.props.dispatch(
          setError("Error processing card data. The card has not been charged.")
        );
    } else {
      this.paymentUpdate(res.opaqueData);
    }
  };

  paymentUpdate = (opaqueData) => {
    const { info } = this.state;
    const { renter } = this.props;
    const { dataDescriptor, dataValue } = opaqueData;

    if (!info || !renter) return this.setInfoError();

    const paymentData = {
      data_description: dataDescriptor,
      data_value: dataValue,
      contract_id: this.props.id,
      amount: parseFloat(this.props.amount),
      email: this.state.email,
      address: this.state.address,
      city: this.state.city,
      state: this.state.state,
      zip: this.state.zip,
      full_name: `${this.props.renter.first_name} ${this.props.renter.last_name}`,
      first_name: this.props.renter.first_name,
      last_name: this.props.renter.last_name,
      info,
    };

    infoCheck(info, renter.id)
      .then(({ data }) => {
        if (!data) {
          return this.setInfoError();
        }

        return this.props.dispatch(postPayment(paymentData));
      })
      .catch((err) => {
        this.setInfoError();
      });
  };

  setInfoError = () => {
    this.props.dispatch(
      setError(
        `We couldn't verify this card. Call Atwood Rentals at 833-786-4822`
      )
    );
  };

  render() {
    if (!this.props.term) {
      return (
        <Warning
          color="yellow"
          icon="ban"
          header="Hold Up!"
          subheader="You haven't selected a term"
          step="term"
        />
      );
    }

    if (!this.props.renter.email) {
      return (
        <Warning
          color="yellow"
          icon="ban"
          header="Hold Up!"
          subheader="Don't pay for a contract when you don't have a renter created yet"
          step="renter"
        />
      );
    }

    if (!addressValid(this.props.address)) {
      return (
        <Warning
          color="yellow"
          icon="ban"
          subheader="Address information is incomplete."
          step="term"
          showButton={true}
        />
      );
    }

    if (!this.props.id || !this.props.amount) {
      return (
        <Warning
          color="yellow"
          icon="ban"
          subheader={
            !this.props.id
              ? `This contract hasn't been created yet.`
              : `This contract doesn't have a term selected`
          }
          header="Hold Up!"
          step="term"
          showButton={!this.props.id ? false : true}
        />
      );
    }

    if (!this.props.coisGood) {
      return (
        <Warning
          color="yellow"
          icon="ban"
          header="Hold Up!"
          subheader="COI not in compliance"
          showButton={false}
        />
      );
    }

    if (this.props.payment) {
      return (
        <Segment padded textAlign="center">
          <Icon size="massive" color="green" name="circle check" />
          <h2>Paid</h2>
          {this.props.paymentTransactions.length > 0 && (
            <div>
              {this.props.paymentTransactions.map((pt, i) => (
                <p key={i}>
                  <b>
                    ${pt.amount_formatted} on {pt.date_formatted}
                  </b>
                </p>
              ))}
            </div>
          )}
        </Segment>
      );
    }

    return (
      <Segment padded>
        <Header
          content={`$${this.props.amount}`}
          subheader="Total Down Payment"
          textAlign="center"
          size="huge"
          style={{ fontSize: "2.5em" }}
          color="green"
        />
        {this.props.paymentSkipped && (
          <h3
            style={{
              textAlign: "center",
              fontSize: "20px",
              margin: "0 0 30px 0",
            }}
          >
            Payment Skipped
            <Icon
              name="fast forward"
              // color="teal"
              style={{
                marginLeft: "10px",
              }}
            />
          </h3>
        )}
        <PaymentForm
          email={this.props.renter.email}
          fullName={`${this.props.renter.first_name} ${this.props.renter.last_name}`}
          onSubmit={this.onSubmit}
        />
        {/*
          !this.props.paymentSkipped &&
            <Button
              content="Skip Payment"
              size="huge"
              onClick={() => this.props.dispatch(skipPayment())}
              color="teal"
              icon="fast forward"
              labelPosition="right"
              fluid
              style={{
                marginTop: '20px'
              }}
            />
        */}
      </Segment>
    );
  }
}

function mapStateToProps(state) {
  return {
    address: state.address,
    amount: state.term.selected
      ? state.term.selected.total_purchase_reserve
      : "0.00",
    coisGood: state.coisGood,
    id: state.id,
    payment: state.payment,
    paymentSkipped: state.paymentSkipped,
    paymentTransactions: state.paymentTransactions,
    renter: state.renter,
    term: state.term.selected,
  };
}

export default connect(mapStateToProps)(Payment);

function infoCheck(info, renterId) {
  if (!info || !renterId) return true;

  return axios.post(`/infos/info-check/`, {
    info,
    renter_id: renterId,
  });
}
